export const LAYOUTS = {
    ONE: {
        id: "one",
        columns: 1,
        cells: [
            { colSpan: 1, rowSpan: 1 }
        ]
    },
    TWO: {
        id: "two",
        columns: 2,
        cells: [
            { colSpan: 1, rowSpan: 1 },
            { colSpan: 1, rowSpan: 1 }
        ]
    },

    FOUR: {
        id: "four",
        columns: 2,
        cells: [
            { colSpan: 1, rowSpan: 1 },
            { colSpan: 1, rowSpan: 1 },
            { colSpan: 1, rowSpan: 1 },
            { colSpan: 1, rowSpan: 1 }
        ]
    },

    NINE: {
        id: "nine",
        columns: 3,
        cells: Array.from({ length: 9 }, () => ({
            colSpan: 1,
            rowSpan: 1
        }))
    }
};